<template>
  <div class="order-warn">
    <div v-for="(val,ind) in data" :key="ind" class="flex order-warp">
      <div v-for="(item,index) in val.orderList" :key="`${index}a`" class="order-inner"
           :class="{'border-before': index === 1}">
        <div class="margin-bottom"><span class="order-title">订单编号：</span> {{ item.orderId | defaultShow }}</div>
        <div class="margin-bottom"><span class="order-title">订单采购时间：</span> {{ item.purchaseDate | defaultShow }}</div>
        <div class="flex order-bottom">
          <img :src="item.image"/>
          <div>
            <div class="margin-bottom height-20">
              <span class="color-grey">ASIN：</span>
              <gj-link :href="item.asinUrl" target="_blank">{{ item.asin | defaultShow }}</gj-link>
              <gj-copy-icon class="icon-show" v-if="item.asin" :content="item.asin"></gj-copy-icon>
            </div>
            <div class="margin-bottom height-20">
              <span class="color-grey">MSKU：</span>
              <span>{{ item.msku | defaultShow }}</span>
              <gj-copy-icon class="icon-show" v-if="item.msku" :content="item.msku"></gj-copy-icon>
            </div>
            <div><span class="color-grey">FBA配送费：</span> <span
                :class="{'color-red': index === 1}">{{ val.currency }}{{ item.fbaFees | defaultShow }} </span></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "order-warn",
  props: {
    data: {
      type: [Array, Object],
      default: null
    },
    warnTitleCode: {
      type: String,
      default: ''
    }
  },
}
</script>

<style scoped lang="scss">
.order-warn {
  font-size: 14px;
  color: #333;

  .order-warp {
    width: 600px;
    border: 1px solid #E4E5E6;
    border-radius: 12px;
    padding: 16px 12px;
    line-height: 20px;

    .icon-show {
      display: none;
    }

    &:hover {
      .icon-show {
        display: inline-block;
      }
    }

    .order-inner {
      width: 300px;
      box-sizing: border-box;
    }

    .border-before {
      position: relative;
      padding-left: 12px;

      &::before {
        position: absolute;
        display: block;
        top: 4px;
        left: 0;
        width: 1px;
        background: #E4E5E6;
        height: 124px;
        content: '';
      }
    }


    .margin-bottom {
      margin-bottom: 8px;
    }

    .order-title {
      display: inline-block;
      width: 106px;
      text-align: right;
      color: #666;
    }

    .color-grey {
      color: #666;
    }

    .color-red {
      color: #F5222D;
    }

    .order-bottom {
      > img {
        width: 42px;
        height: 34px;
        margin-right: 20px;
        margin-top: 5px;
      }

      /deep/ .el-link {
        font-size: 14px;
      }

      /deep/ .el-icon-copy-document {
        color: #979797;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }

  .height-20 {
    height: 20px;
  }
}
</style>
